module.exports = __webpack_public_path__ + "img/download-icon.a91926ad.svg";